<template>
  <TemplateContentAside>
    <template #header>
      <heading tag="h1"> Mon compte </heading>
    </template>
    <template #aside><AccountAside /></template>
    <DisplaySection>
      <section>
        <AccountUserProfileData />
      </section>
      <hr />
      <AccountCommonSettings />
      <AccountOtherSettings />
      <AccountLogout />
    </DisplaySection>
  </TemplateContentAside>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
section {
  display: flex;
  flex-direction: column;
  gap: var(--gap_l);
}
hr {
  width: 10rem;
  height: 0.05rem;
  margin: 0.6rem auto;
  border: none;
  background-color: var(--color_neutral_100);
}
</style>
